import { type ReactNode } from 'react';
import type { FileData } from '../FilesPanel';

export enum BlockDataValueType {
  STRING,
  FILE,
  FILE_ARRAY,
}

export type BlockDataItem = {
  label: ReactNode;
  value: ReactNode | FileData | FileData[];
  valueType?: BlockDataValueType;
  defaultValue?: string;
};
